<template>
    <v-container>        
        <v-flex d-inline-flex>
            <span>
            {{ dateRange[0] }}
            </span>

            <v-range-slider
                v-model="dateRange"
                :max="2023"
                :min="1901"
                :step="1"
            ></v-range-slider>

            <span>
            {{ dateRange[1] }}
            </span>

            </v-flex>
        <loader v-if="loading"/>
        <chart v-if="!loading" :chartData="chartData"/>
    </v-container> 
</template>

<script>
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
import Loader from '@/components/Loader.vue';

import Chart from './Chart.vue';

// Helper function to format the date as required
function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export default {
    components: {
        Chart,
        Loader
    },
    created() {
        this.initialise();
    },
    data() {
        return {
            loading: true,
            items: [],
            dateRange: [2013, 2023]
        }        
    },
    methods: {
        initialise() {
            axios.get(`api/StatisticalInformation/Sankey`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        getUniqueArray(arr) {
        const uniqueSet = new Set();
        return arr.filter(item => {
            const key = `${item.date}-${item.party}`;
            if (uniqueSet.has(key)) {
            return false;
            } else {
            uniqueSet.add(key);
            return true;
            }
        });
        }        
    },
    computed: {
        filteredItems() {
            const startDate = new Date(`${this.dateRange[0]}-01-01T00:00:00`);
            const endDate = new Date(`${this.dateRange[1]}-12-31T23:59:59`);

            return this.items.filter(item => {
                const itemDate = new Date(item.Date);
                return itemDate >= startDate && itemDate <= endDate;
            });
        },
        chartData() {
            let nodes = this.filteredItems.map(i => ({
                date: formatDate(i.Date),
                party: i.Party,
                partyColour: i.PartyColour
            }));
            this.getUniqueArray(nodes);
            nodes = nodes.map(n => ({
                id: `${n.party} - ${n.date}`,
                color: n.partyColour                
            }));



        // Step 1: Group data by election year and electorate
        const electionResults = {};

        this.filteredItems.forEach(entry => {
            const year = entry.Date.slice(0, 4);
            const formattedDate = formatDate(entry.Date);
            const party = entry.Party;
            const electorate = entry.Electorate;
            if (!electionResults[year]) {
                electionResults[year] = {};
            }
            if (!electionResults[year][formattedDate]) {
                electionResults[year][formattedDate] = {};
            }
            electionResults[year][formattedDate][electorate] = party;
        });

        // Step 2: Generate flows based on electorate control for consecutive elections and accumulate counts
        const flowCounts = {};
        const years = Object.keys(electionResults).sort();

        for (let i = 0; i < years.length - 1; i++) {
            const currentYear = years[i];
            const nextYear = years[i + 1];
            const currentDates = Object.keys(electionResults[currentYear]);
            const nextDates = Object.keys(electionResults[nextYear]);

            for (const currentDate of currentDates) {
                const currentResults = electionResults[currentYear][currentDate];
                for (const nextDate of nextDates) {
                    const nextResults = electionResults[nextYear][nextDate];

                    // Track electorates that have been processed
                    const processedElectorates = new Set();

                    for (const electorate in currentResults) {
                        if (nextResults.hasOwnProperty(electorate)) {
                            const partyFrom = currentResults[electorate];
                            const partyTo = nextResults[electorate];
                            const flowKey = `${partyFrom} - ${currentDate}->${partyTo} - ${nextDate}`;
                            if (!flowCounts[flowKey]) {
                                flowCounts[flowKey] = 0;
                            }
                            flowCounts[flowKey]++;
                            processedElectorates.add(electorate);
                        }
                    }

                    // Handle new electorates
                    for (const electorate in nextResults) {
                        if (!processedElectorates.has(electorate)) {
                            const partyTo = nextResults[electorate];
                            const flowKey = `new - ${nextDate}->${partyTo} - ${nextDate}`;
                            if (!flowCounts[flowKey]) {
                                flowCounts[flowKey] = 0;
                            }
                            flowCounts[flowKey]++;
                        }
                    }
                }
            }
        }

        // Step 3: Convert the flowCounts dictionary to the desired array format
        const flows = Object.entries(flowCounts).map(([key, value]) => {
            const [partyFrom, partyTo] = key.split('->');
            return [partyFrom, partyTo, value];
        });


            return {
                title: {
                    text: 'Seat changes over time'
                },
                chart: {
                    height: 768
                },
                accessibility: {
                    point: {
                        valueDescriptionFormat: '{index}. {point.from} to {point.to}, ' +
                            '{point.weight}.'
                    }
                },
                tooltip: {
                    headerFormat: null,
                    pointFormat:
                '{point.fromNode.name} \u2192 {point.toNode.name}: {point.weight:.0f} ' +
                'seats',
                    nodeFormat: '{point.name}: {point.sum:.0f} seats'
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                series: [{
                    keys: ['from', 'to', 'weight'],
                    nodes,
                    data: flows,
                    type: 'sankey',
                    name: 'Seats over time'
                }]                
            };
        }
    }
}
</script>

<style>

</style>